import React, { createContext, useState } from 'react';

export const SelectedOfferContext = createContext();

export const SelectedOfferProvider = ({ children }) => {
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [advancePaymentState, setAdvancePaymentState] = useState({
    method: null,
    status: 'pending',
    payload: null,
  });

  return (
    <SelectedOfferContext.Provider
      value={{
        selectedOffer,
        setSelectedOffer,
        advancePaymentState,
        setAdvancePaymentState,
      }}
    >
      {children}
    </SelectedOfferContext.Provider>
  );
};